export default __webpack_public_path__ + "static/media/Screenshot (16).aa069130.png";